import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { getCurrentInstance, Ref } from '@vue/composition-api'
import { computed, ref, toRefs, watch } from '@nuxtjs/composition-api'
import { debounce } from '~/utils/function'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import { computeFieldState } from '~/utils/form'

export function useDynamicForm(
  props: typeof DYNAMIC_FORM_FIELD_PROPS,
  {
    onValue,
    onError
  }: {
    onValue?: ((v: Ref<any>) => void) | null
    onError?: ((v: Ref<any>) => void) | null
  } = {
    onValue: null,
    onError: null
  }
) {
  const { emit } = getCurrentInstance() as any

  const { fieldError, fieldValue } = toRefs(props)

  const value = ref<any | null>(null)
  const error = ref<string | null>(null)

  function changeValue(name: string, value: any) {
    emit('change', [{ name, value }])
  }

  function changeValues(
    changePayloads: {
      name: string
      value: any
    }[]
  ) {
    emit('change', changePayloads)
  }

  const changeValueWithDebounce = debounce((name: string, value: any) => {
    changeValue(name, value)
  }, DEBOUNCE_DEFAULT)

  const isValid = computed(() => computeFieldState(error.value))

  watch(fieldError, e => (onError ? onError(ref(e)) : (error.value = e)), {
    immediate: true
  })
  watch(fieldValue, v => (onValue ? onValue(ref(v)) : (value.value = v)), {
    immediate: true
  })

  return {
    isValid,
    value,
    error,
    onValue,
    onError,
    changeValue,
    changeValues,
    changeValueWithDebounce
  }
}
